<script lang="ts">
	import Knob from './Knob.svelte';

	export let step: string = '0';
	export let min: number = 10;
	export let max: number = 100;
	export let callback: (start: number, end: number) => void;

	$: stepVal = parseFloat(step);
	$: exp = (isNaN(stepVal) || !isFinite(stepVal)) ? 0 : Math.log10(stepVal);
	$: isActive = dragActive.a || dragActive.b;
	$: percentStart = (values.start - min) / (max - min) * 100;
	$: percentLength = (values.end - min) / (max - min) * 100 - percentStart;

	let values: {start: number, end: number} = {start: min, end: max};
	let dragActive: {a: boolean, b: boolean} = {a: false, b: false};
	let lineElement = null;
	let lineWidth: number = 0;
	let lineOffset: number = 0;
</script>

<div class="product-slider-widget--inner">
	<div class="product-slider-widget--slider">
		<div class="product-slider-widget--slider--line" bind:clientWidth={lineWidth} bind:this={lineElement}>
			<div class="product-slider-widget--slider--line--distance{isActive ? ' active' : ''}" style="left: {percentStart}%; width: {percentLength}%;"></div>
			{#if percentStart < 50}
				<!-- If the start-percentage is below 50%, than the end-knob has a higher z-index than the start-knob -->
				<Knob type="is-s" lineElement={lineElement} lineWidth={lineWidth} min={min} max={max} minBound={min} maxBound={values.end} exp={exp} bind:value={values.start} bind:dragActive={dragActive.a} on:change={() => callback(values.start, values.end)}></Knob>
				<Knob type="is-e" lineElement={lineElement} lineWidth={lineWidth} min={min} max={max} minBound={values.start} maxBound={max} exp={exp} bind:value={values.end} bind:dragActive={dragActive.b} on:change={() => callback(values.start, values.end)}></Knob>
			{:else}
				<Knob type="is-e" lineElement={lineElement} lineWidth={lineWidth} min={min} max={max} minBound={values.start} maxBound={max} exp={exp} bind:value={values.end} bind:dragActive={dragActive.b} on:change={() => callback(values.start, values.end)}></Knob>
				<Knob type="is-s" lineElement={lineElement} lineWidth={lineWidth} min={min} max={max} minBound={min} maxBound={values.end} exp={exp} bind:value={values.start} bind:dragActive={dragActive.a} on:change={() => callback(values.start, values.end)}></Knob>
			{/if}
		</div>
	</div>
	<div class="price-input-end">
		<input type="number" class="form-control" bind:value={values.start} step={step} min={min} max={max} on:change={() => callback(values.start, values.end)} />
	</div>
	<div class="price-input-start">
		<input type="number" class="form-control" bind:value={values.end} step={step} min={min} max={max} on:change={() => callback(values.start, values.end)} />
	</div>
</div>

<style type="text/scss">
	$knob-diameter: 1em;

	.product-slider-widget--inner {
		display: grid;
		gap: .5em;
		grid-template-columns: 1fr 1fr;
	}

	.product-slider-widget--slider {
		padding: $knob-diameter / 2;
		grid-column: 1 / span 2;
	}

	.product-slider-widget--slider--line {
		border-top: 1px solid gray;
		position: relative;
		max-height: 1px;
		min-width: 96px;
	}

	.product-slider-widget--slider--line--distance {
		position: absolute;
	}
</style>
